<!--
 * @Author: 汪俊洪
 * @Date: 2025-04-27 10:41:05
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2025-06-05 17:19:01
 * @Description:
-->
<template>
  <div class="wrap">
    <div style="flex: 1; overflow: hidden">
      <el-table
        class="plc-table plc-table-checkbox"
        :data="tableData"
        style="width: 100%"
        row-key="plcSkuId"
        ref="multipleTable"
      >
        <el-table-column
          prop="date"
          header-align="center"
          width="370px"
          label="商品信息"
        >
          <template slot-scope="scope">
            <div class="goods-info">
              <div>
                <el-image
                  class="fileUrl"
                  :src="scope.row.fileUrl"
                  :preview-src-list="[scope.row.fileUrl]"
                >
                </el-image>
                <span class="invalidStateSku" v-if="scope.row.invalidStateSku"
                  >商品已失效</span
                >
              </div>
              <div class="goods-right">
                <h2 class="skuName ell_two">{{ scope.row.skuName }}</h2>
                <div class="plc-des">
                  <span class="plc-des-label">型号：</span>
                  <span class="plc-des-value">{{ scope.row.model }}</span>
                </div>
                <div class="plc-des">
                  <span class="plc-des-label">规格：</span>
                  <span class="plc-des-value">{{
                    scope.row.specification
                  }}</span>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="discountSellingPrice"
          label="单价（元）"
        >
          <template slot-scope="scope">
            <div class="plc-des nowrap">
              <span class="plc-des-label">价格：</span>
              <span class="plc-des-value show-money"
                >￥{{ scope.row.discountSellingPrice | formatePrice }}</span
              >
            </div>
            <div class="plc-des">
              <span class="plc-des-label">折扣：</span>
              <span class="plc-des-value"
                >{{ (scope.row.discountRate || 0) * 10 }}折</span
              >
            </div>
            <div class="plc-des">
              <span class="plc-des-label">标准价：</span>
              <span class="plc-des-value">{{
                scope.row.sellingPrice | formatePrice
              }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="plcSkuCode" align="center" label="中控物料编码">
        </el-table-column>
        <el-table-column prop="skuCode" align="center" label="平台编码">
        </el-table-column>
        <el-table-column prop="goodsNum" align="center" label="数量">
        </el-table-column>
        <el-table-column prop="goodsUnit" align="center" label="单位">
        </el-table-column>
        <el-table-column
          align="center"
          prop="discountSellingPriceTotal"
          label="含税小计（元）"
        >
          <template slot-scope="scope">
            <span class="show-money"
              >￥{{ scope.row.discountSellingPriceTotal | formatePrice }}</span
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { formatePrice } from '@/utils/formatePrice'

export default {
  props: {
    tableData: {
      type: Array,
      default: () => []
    }
  },
  filters: {
    formatePrice (val) {
      if (val) {
        if (typeof val !== 'number') {
          val = val - 0
        }
        return formatePrice(val.toFixed(2))
      }
      if (val === null) {
        return '-'
      }
      return '0.00'
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  display: flex;
  flex-direction: column;
}
.goods-info {
  display: flex;
  align-items: center;
  .fileUrl {
    width: 131px;
    margin-right: 16px;
  }
  .skuName {
    font-size: 14px;
    font-weight: 700;
    color: #333333;
    margin: 0 0 14px;
  }
  .goods-right {
    flex: 1;
  }
}

.plc-des {
  text-align: left;
  margin-bottom: 9px;
}

.show-money {
  font-size: 20px;
  font-weight: 900;
  color: #e93037;
}

.plc-bottom {
  .plc-bottom1 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 9.5px 16px;
    flex: 1;
  }
  .selected-num {
    font-size: 12px;
    color: #000;
    span {
      color: #ff0000;
    }
  }
  .plc-bottom1-right {
    display: flex;
    align-items: center;
    .btn {
      font-size: 18px;
      font-weight: bold;
      line-height: 20px;
      margin-left: 12px;
      padding: 8px 12px;
      background: #2a54d1;
      border-radius: 8px;
      color: #fff;
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
      &.to-buy {
        background: #ff4c2b;
      }
    }
  }
  .plc-pagination {
    border-top: 1px solid #eeeeee;
  }
  .del-btn {
    color: #ff4c2b;
    margin-left: 26px;
  }
}

.nowrap {
  white-space: nowrap;
}
</style>
